import { useQuery } from "@tanstack/react-query";
import {
  EmissionFactorDTO,
  getEmissionFactors,
  getEmissionFactorsBySite,
  getScientificUnit,
} from "api";
import { QUERY_KEYS } from "consts";

export const useEmissionFactors = (enabled = true) =>
  useQuery<EmissionFactorDTO[]>(
    [QUERY_KEYS.EMISSION_FACTORS],
    getEmissionFactors,
    { enabled },
  );

export const useEmissionFactorsBySite = (enabled = true) =>
  useQuery<EmissionFactorDTO[]>(
    [QUERY_KEYS.EMISSION_FACTOR_BY_SITE],
    getEmissionFactorsBySite,
    { enabled },
  );

export const useScientificUnit = (enabled = true) =>
  useQuery<any>(
    [QUERY_KEYS.SCIENTIFIC_UNIT],
    getScientificUnit,
    { enabled },
  );

